export const cars = [
    {
        src : "/cars/2007-dodge-magnum-sxt-4dr-wagon.jpg",
        title: "2007 Dodge Magnum SXT",
        price: "1495.00",
        miles: "106,123",
        engine: "3.5L V-6",
        options: ["Power Windows", "Power Brakes", "Grey Interior", "Automatic Transmission"]
    },
    {
        src: "/cars/1994-pontiac-grand-am-se-4dr-sedan.jpg",
        title: "1994 Pontiac Grand Am",
        price: "2495.00",
        miles: "95,886",
        engine: "3.1L V-6",
        options: ["Power Windows", "Power Brakes", "Grey Interior", "Automatic Transmission"]
    },
    {
        src: "/cars/1997-saturn-s-series-sl2-4dr-sedan.jpg",
        title: "1997 Saturn Sl2",
        price: "2995.00",
        miles: "146,145",
        engine: "1.9L I-4",
        options: ["Power Windows", "Power Brakes", "Green Interior", "Automatic Transmission"]
    },
    {
        src: "/cars/2000-oldsmobile-alero-gl-4dr-sedan.jpg",
        title: "2000 Oldsmobile Alero GL",
        price: "2495.00",
        miles: "145,067",
        engine: "2.4L I-4",
        options: ["Power Windows", "Power Brakes", "Green Interior", "Automatic Transmission"]

    }
]